import React, { Component } from 'react'
import { Button } from 'react-bootstrap';
import { Form, Table, Container } from 'react-bootstrap';
import config from '../../config';


export class factorprecio extends Component {
    constructor(props) {
        const currentCompany = sessionStorage.getItem('company');
        super(props);
        this.state = {
            unidades: [],
            defaultunidades: [],
            currentCompany,
            changed: false,
            showdetail: false
        }
    }

    modifyUnit = ({ target }, data) => {
        const { unidades } = this.state;
        const { name } = target;
        const value = (target.type === "checkbox") ? target.checked : target.value;
        unidades.forEach((element) => {
            if (name === "UNIDAD_PRINCIPAL") {
                element.UNIDAD_PRINCIPAL = false;
            }
            if (element.ID_UNIDADES === data.ID_UNIDADES) {
                element[name] = value;
                if (element.UNIDAD_PRINCIPAL === true) {
                    element.FACTOR = 1;
                    element.UNIDAD_VENTA = true;
                    element.UNIDAD_COSTO = true;
                }
                if (element.UNIDAD_PRINCIPAL || element.UNIDAD_VENTA || element.UNIDAD_COSTO) {
                    element.ESTADO = true;
                } else {
                    element.ESTADO = false;
                    element.FACTOR = 0;
                    element.PRECIO = 0;
                }
            }
        });
        this.setState({ unidades, changed: true });
    }
    changeList = ({ target }, item) => {
        const { currentCompany } = this.state;
        const id_lista = target.value;
        const id_item = item;
        if (id_lista !== "") {
            const datasend = {
                method: 'POST',
                body: JSON.stringify(
                    {
                        id_lista,
                        id_item
                    }
                ),
                headers: {
                    'Content-Type': 'application/json',
                    'tipo': this.state.tipo,
                    'empresa': currentCompany
                }
            };

            fetch(config.servBackEnd + '/items/infounitprice', datasend)
                .then(response => response.json())
                .then(data => {
                    if (data.ok) {
                        const unidades = data.data[0];
                        const defaultunidades = data.data[1];
                        this.setState({
                            unidades,
                            defaultunidades,
                            showdetail: true
                        });
                    }
                })
        } else {
            this.setState({ showdetail: false })
        }
    }
    cancelar = () => {
        const { defaultunidades } = this.state;
        this.setState({
            unidades: defaultunidades,
            changed: false
        })
    }

    aceptar = (unit, item) => {
        const { aceptarCambios } = this.props;
        const { currentCompany } = this.state;
        const { unidades } = this.state;
        const datasend = {
            method: 'POST',
            body: JSON.stringify({ unit }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
                'empresa': currentCompany
            }
        };

        fetch(config.servBackEnd + '/units/itemunit/' + item, datasend)
            .then(response => response.json())
            .then(data => {
                data.forEach(element => {
                    if (element.data) {
                        const info = element.data;
                        unidades.forEach(elementUni => {
                            if (element.id_unidad === elementUni.ID_UNIDADES && info.insertId > 0) {
                                elementUni.ID_ITEM_UNIDADES = info.insertId;
                            }
                        });
                    }
                });
            })
        this.setState({
            defaultunidades: unit,
            unidades: unit,
            changed: false
        })
        aceptarCambios(unit);
    }
    render() {
        const { showUnit } = this.props;
        const { unidades, showdetail } = this.state;
        const precios = this.props.precio ? this.props.precio : [];
        const { item } = this.props;
        const changeList = this.changeList
        const modifyUnit = this.modifyUnit;
        return (
            <Container>
                <Table>
                    <thead>
                        <tr>
                            <th colSpan="6">ASIGNACION DE PRECIOS POR UNIDAD DE MEDIDA</th>
                        </tr>
                        <tr>
                            <th colSpan="6">
                                <Form.Control as="select" onChange={e => changeList(e, item)} disabled={this.state.changed}>
                                    <option value="">Seleccione</option>
                                    {precios.map((precio, i) => {
                                        return <option key={'p' + i} value={precio.ID_LISTA_PRECIOS} >{precio.NOMBRE_LISTA}</option>;
                                    })}

                                </Form.Control>
                            </th>
                        </tr>
                        <tr>
                            <th>UNIDAD INVENTARIO</th>
                            <th>UNIDAD VENTA</th>
                            <th>UNIDAD COMPRA</th>
                            <th>DESCRIPCION UNIDAD</th>
                            <th>FACTOR</th>
                            <th>PRECIO</th>
                        </tr>
                    </thead>
                    {showdetail && <tbody>
                        {
                            unidades.map((unidad, i) => {
                                if (unidad.UNIDAD_PRINCIPAL === true) {
                                    unidad.FACTOR = 1;
                                    unidad.UNIDAD_VENTA = true;
                                    unidad.UNIDAD_COSTO = true;
                                }
                                if (showUnit) {
                                    return (<tr key={'tru' + i}>
                                        <td><input name="UNIDAD_PRINCIPAL" type="checkbox" onChange={(e) => modifyUnit(e, unidad)} checked={unidad.UNIDAD_PRINCIPAL} />  </td>
                                        <td><input name="UNIDAD_VENTA" type="checkbox" onChange={(e) => modifyUnit(e, unidad)} checked={unidad.UNIDAD_VENTA} disabled={unidad.UNIDAD_PRINCIPAL} />  </td>
                                        <td><input name="UNIDAD_COSTO" type="checkbox" onChange={(e) => modifyUnit(e, unidad)} checked={unidad.UNIDAD_COSTO} disabled={unidad.UNIDAD_PRINCIPAL} />  </td>
                                        <td>{unidad.DESCRIPCION_UNIDAD} </td>
                                        <td><Form.Control name="FACTOR" min="1.01" type="number" step="0.01" onChange={(e) => modifyUnit(e, unidad)} value={unidad.FACTOR} disabled={unidad.UNIDAD_PRINCIPAL || !unidad.ESTADO} /></td>
                                        <td><Form.Control name="PRECIO" type="number" step="0.01" onChange={(e) => modifyUnit(e, unidad)} value={unidad.PRECIO} disabled={!unidad.ESTADO} /></td>
                                    </tr>
                                    )
                                } else {
                                    return null;
                                }
                            })
                        }
                    </tbody>}
                    {showdetail &&
                        <tfoot>
                            <tr>
                                <td colSpan="3"><Button onClick={this.cancelar} variant="outline-danger"> Cancelar cambio </Button></td>
                                <td colSpan="3"><Button onClick={() => this.aceptar(unidades, item)} variant="outline-success"> Aceptar cambio </Button></td>
                            </tr>
                        </tfoot>}
                </Table>
                {/*  <Tab eventKey="precios" title="Precios">
                        <div className='mt-3'>
                            <Table>
                                <thead>
                                    <tr>
                                        <th colSpan="2">ASIGNACION DE PRECIOS</th>
                                        <th></th>
                                    </tr>
                                    <tr>
                                        <th>LISTA DE PRECIOS</th>
                                        <th>PRECIO ITEM</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody style={{ width: 300 }}>
                                    <tr>
                                        <th>
                                            <Form.Group as={Col} controlId="listaini">
                                                <Form.Control name="lista" as="select" onChange={e => this.setState({ new_list: e.target.value })}>
                                                    <option value="">Seleccione</option>
                                                    {precios.map((precio, i) => {
                                                        return <option key={'p' + i} value={precio.ID_LISTA_PRECIOS} >{precio.NOMBRE_LISTA}</option>;
                                                    })}

                                                </Form.Control>
                                            </Form.Group>
                                        </th>
                                        <th>
                                            <center>
                                                <Form.Group as={Col} controlId="precioini">
                                                    <Form.Control name="precio" style={{ width: 300 }} type="number" placeholder="Ingrese un precio" value={this.state.precio} onChange={e => this.setState({ new_price: e.target.value })} />
                                                </Form.Group>
                                            </center>
                                        </th>
                                        <th><Button variant="primary" onClick={this.asignarPrecio}>Agregar Precio</Button></th>

                                    </tr>
                                    <tr>
                                        <th>Lista agregada</th>
                                        <th>Precio asignado</th>
                                    </tr>
                                    {
                                        listasPrecios.map((element, i) => {
                                            if (element.ESTADO === 1) {
                                                return (
                                                    <tr key={i}>

                                                        <th>
                                                            <center>
                                                                <Form.Group as={Col} controlId="">
                                                                    <Form.Control style={{ width: 300 }} type="text" value={element.NOMBRE_LISTA} readOnly />
                                                                </Form.Group>
                                                            </center>
                                                        </th>

                                                        <th>
                                                            <center>
                                                                <Form.Group as={Col} controlId="">
                                                                    <Form.Control style={{ width: 300 }} type="number" value={element.PRECIO} onChange={(e) => { cambiarListaPrecio(element, i, e) }} />
                                                                </Form.Group>
                                                            </center>
                                                        </th>
                                                        <th><Button variant="primary" style={{ background: "red" }} onClick={(e) => { this.removeListPric(element, i, e) }} >Eliminar</Button></th>
                                                    </tr>);
                                            } else {
                                                return null;
                                            }
                                        })

                                    }
                                </tbody>
                            </Table>
                        </div>
                    </Tab>
               */}
            </Container>
        )
    }
}

export default factorprecio



// WEBPACK FOOTER //
// ./src/components/subcomponent/factorprecio.jsx